import React from 'react';
import * as icons from "../../../assets/svg/login-icons";

const HelpButton = ({ t, language, onChatOpen }) => {
  const isHebrew = language === 'he';

  const handleHelpClick = () => {
    // Call the onChatOpen callback to open the embedded chat
    if (onChatOpen) {
      onChatOpen();
    }
  };

  return (
    <div
      onClick={handleHelpClick}
      className="whatsapp-helper-btn"
      style={{
        display: 'flex',
        gap: '10px',
        cursor: 'pointer',
        textDecoration: 'none',
        marginTop: '5px',
        flexDirection: isHebrew ? 'row-reverse' : 'row',
      }}
    >
      <div className="whatsapp-helper-btn-text" style={{ color: 'black' }}>
        {t("login.whatsapp.help")}
      </div>
      <div className="whatsapp-helper-btn-icon">
        {icons.SupportIcon()}
      </div>
      <div className="whatsapp-helper-btn-text-contact" style={{ color: '#42C0B4', fontWeight: '700' }}>
        {t("login.whatsapp.contact")}
      </div>
    </div>
  );
};

export default HelpButton;
